module.exports = __webpack_public_path__ + "src/app/_content/imgs/mini/discover/BMW_eShop.jpg?6a503c99ee6898d40f6bbe2e1cc04d1c";